
import { sync } from 'vuex-pathify'

export default {
  vessel: {
    wrapper: {
      position: 'fixed',
      pinBottom: true,
      pinRight: true,
      margin: 'sm',
      shadow: true,
      borderRadius: 'lg',
      zIndex: 50,
      lineHeight: 'sm',
      fontSize: 'sm',
      maxWidth: 'full',
      overflow: 'hidden',
      width: '3xl',
      md: {
        margin: 'md'
      }
    },
    icon: {
      fontSize: 'lg',
      cursor: 'pointer',
      padding: '2xs',
      margin: 'sm',
      backgroundColor: 'white',
      color: 'primary',
      shadow: true,
      borderRadius: 'full'
    }
  },
  computed: {
    visible: sync('expoPopup'),
    showBanner() {
      return this.config.enabled == true
    },
    imagePath() {
      return this.config.image || '/expo-popup.png'
    }
  },
  created() {
    this.config = this.$config.expoPopup || {}
  }
}
